{
  "help": "Pomoč",
  "info": "Informacije"
}
